import { Layout } from "@/components/layout/Layout";
import { InstatusOutageBanner } from "@/components/status/InstatusOutageBanner";
import { AuthWrapper } from "@/components/wrappers/AuthWrapper";
import { AdminRouteWrapper } from "@/components/wrappers/AdminRouteWrapper";
import { OrgAdminRouteWrapper } from "@/components/wrappers/OrgAdminRouteWrapper";
import { AuthRedirect } from "@/pages/auth/AuthRedirect";
import { InvalidEmail } from "@/pages/auth/InvalidEmail";
import { InvitationSend } from "@/pages/auth/InvitationSend";
import Login from "@/pages/auth/Login";
import { PasswordLess } from "@/pages/auth/PasswordLess";
import { TokenExpired } from "@/pages/auth/TokenExpired";
import { DashboardPage } from "@/pages/dashboard/DashboardPage";
import { EstimationDetailPage } from "@/pages/estimation-detail";
import { NotFoundPage } from "@/pages/not-found/NotFoundPage";
import { SettingsLayout, SettingsIndexRedirect } from "@/components/layout/settings/SettingsLayout";
import { SettingsProfilePage } from "@/pages/settings/SettingsProfilePage";
import { ManageUsersPage } from "@/pages/settings/ManageUsersPage";
import { OfficesSettingsPage } from "@/pages/settings/OfficesSettingsPage";
import { PhotoLabelsSettingsPage } from "@/pages/settings/PhotoLabelsSettingsPage";
import { AdminPage } from "@/pages/admin/AdminPage";
import { ValueAddPage } from "@/pages/admin/ValueAddPage";
import { IssueRatePage } from "@/pages/admin/IssueRatePage";
import { AnalyticsPage } from "@/pages/analytics/AnalyticsPage";
import ErrorBoundary from "@/sentry/ErrorBoundary";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

export const AppRoutes = () => {
  return (
    <Router>
      <ErrorBoundary>
        <div className="flex h-svh flex-col">
          <InstatusOutageBanner />
          <div className="relative flex min-h-0 flex-1 flex-col">
            <Routes>
              {/* Public */}
              <Route path="/" element={<Login />} />
              <Route path="/passwordLess" element={<PasswordLess />} />
              <Route path="/auth-redirect" element={<AuthRedirect />} />
              <Route path="/token-expired" element={<TokenExpired />} />
              <Route path="/invitation-sent" element={<InvitationSend />} />
              <Route path="/invalid-email" element={<InvalidEmail />} />

              {/* Protected */}
              <Route
                path="/dashboard"
                element={
                  <AuthWrapper>
                    <Layout />
                  </AuthWrapper>
                }
              >
                <Route index element={<DashboardPage />} />
              </Route>

              <Route
                path="/analytics"
                element={
                  <AuthWrapper>
                    <Layout />
                  </AuthWrapper>
                }
              >
                <Route index element={<AnalyticsPage />} />
              </Route>

              {/* Admin Routes */}
              <Route
                path="/admin"
                element={
                  <AuthWrapper>
                    <AdminRouteWrapper>
                      <Layout />
                    </AdminRouteWrapper>
                  </AuthWrapper>
                }
              >
                <Route index element={<AdminPage />} />
                <Route path="value-add" element={<ValueAddPage />} />
                <Route path="issuerate" element={<IssueRatePage />} />
              </Route>

              <Route
                path="/estimate/:estimateId"
                element={
                  <AuthWrapper>
                    <Layout />
                  </AuthWrapper>
                }
              >
                <Route index element={<EstimationDetailPage />} />
              </Route>

              <Route
                path="/settings"
                element={
                  <AuthWrapper>
                    <SettingsLayout />
                  </AuthWrapper>
                }
              >
                <Route index element={<SettingsIndexRedirect />} />
                <Route path="profile" element={<SettingsProfilePage />} />
                <Route
                  path="users"
                  element={
                    <OrgAdminRouteWrapper>
                      <ManageUsersPage />
                    </OrgAdminRouteWrapper>
                  }
                />
                <Route
                  path="offices"
                  element={
                    <OrgAdminRouteWrapper requireFlag="MANAGE_OFFICES_ENABLED">
                      <OfficesSettingsPage />
                    </OrgAdminRouteWrapper>
                  }
                />
                <Route
                  path="photo-labels"
                  element={
                    <OrgAdminRouteWrapper requireFlag="PHOTO_LABELS_ENABLED">
                      <PhotoLabelsSettingsPage />
                    </OrgAdminRouteWrapper>
                  }
                />
              </Route>

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </div>
      </ErrorBoundary>
    </Router>
  );
};
